import { ModulePackFE_FAQDB, ModulePackFE_FindingViewDB, ModulePackFE_PertinentCategoryDB } from './_entity.js';
import { ModuleFE_AvatarMode } from './modules/ModuleFE_AvatarMode.js';
export const ModulePackFE_AdvisorUI = [
    ...ModulePackFE_FindingViewDB,
    ...ModulePackFE_FAQDB,
    ...ModulePackFE_PertinentCategoryDB,
    ModuleFE_AvatarMode
];
//# sourceMappingURL=module-pack.js.map